import React from 'react'
import SimpleImageSlider from "react-simple-image-slider";

const Slider = ({ images }) => {
    const imgs = images.map((img) => ({ url: img }))
    console.log(imgs)
    return (
        <SimpleImageSlider
            width="100%"
            height={300}
            images={imgs}
            showNavs={true}
            navSize={40}
            navMargin={10}
            navStyle={2}
            autoPlay
            useGPURender
        />
    );
}

export default Slider